import React from 'react';
import { GameLayout } from '@/components/layout/GameLayout';
import { CalculatorGame } from '@/components/games/calculator/CalculatorGame';

export default function CalculatorGamePage() {
  return (
    <GameLayout
      title="Calculadora Financiera"
      description="Aprende a realizar cálculos financieros básicos"
    >
      <CalculatorGame />
    </GameLayout>
  );
}
